import { AppWindow, Files, House, LayoutDashboard, ShieldCheck, Star } from "lucide-react";
import { CATEGORY } from "./workspaceCategories";

export const CATEGORY_ICONS = {
  [CATEGORY.ALL]: House,
  [CATEGORY.DASHBOARDS]: LayoutDashboard,
  [CATEGORY.PORTALS]: AppWindow,
  [CATEGORY.PAGES]: Files,
  [CATEGORY.ADMIN]: ShieldCheck,
  [CATEGORY.FAVOURITES]: Star,
};
